import { toISODateOnly } from '../../../../../utils/dateUtils';
import {
  EmployeeScopeFilter,
  useDashboardAbsentTodayQuery,
} from '../../../__generated__/graphql';
import { FilterOption } from '../CommonComponents/WidgetFilter/types';
import { useState } from 'react';

const useAbsentTodayData = (initialFilterBy = EmployeeScopeFilter.MyTeam) => {
  const [filterBy, setFilterBy] = useState(initialFilterBy);
  const { data, loading, error } = useDashboardAbsentTodayQuery({
    variables: {
      from: toISODateOnly(new Date()),
      to: toISODateOnly(new Date()),
      filterBy: filterBy,
      limit: 3,
    },
  });

  const handleChangeFilter = (filter: string) => {
    if (filter === FilterOption.MY_TEAM.toString()) {
      setFilterBy(EmployeeScopeFilter.MyTeam);
    } else {
      setFilterBy(EmployeeScopeFilter.AllCompany);
    }
  };

  return {
    data,
    loading,
    error,
    filterBy,
    handleChangeFilter,
  };
};

export default useAbsentTodayData;
